import { useAuth } from '../hooks/useAuth';
// pages
import Profile from '../pages/Profile/Profile';
import Fundings from '../pages/Fundings/Fundings';
import Funding from '../pages/Funding/Funding';
import NewFunding from '../pages/NewFunding/NewFunding';
import Prospect from '../pages/Prospect/Prospect';
import Consumer from '../pages/Consumer/Consumer';
import Consumers from '../pages/Consumers/Consumers';
import Prospects from '../pages/Prospects/Prospects';
import Dashboard from '../pages/Dashboard/Dashboard';
import Aggregator from '../pages/Aggregator/Aggregator';
import Aggregators from '../pages/Aggregators/Aggregators';
import Reports from '../pages/Reports/Reports';
import Report from '../pages/Report/Report';
import Settings from '../pages/Settings/Settings';
// components
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Spinner } from '../components/Spinner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// navigation
import { Route, Routes, Navigate, useLocation } from 'react-router';

function RoutesWrapperComponent({ location, children }) {
  return location.pathname.includes('/consumer/') ||
    location.pathname.includes('/funding/') ||
    location.pathname.includes('/settings') ? (
    <div className="w-100 h-100 overflow-hidden">{children}</div>
  ) : (
    <Container className="flex-grow-1 mt-5">{children}</Container>
  );
}

function MainRouter() {
  const location = useLocation();
  const { isLoading, error } = useAuth();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return (
      <Row className="align-items-center text-center">
        <Col>
          <Spinner visible text="Loading..." />
        </Col>
      </Row>
    );
  }

  const defaultDashboard = localStorage.getItem('dashboard');

  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <RoutesWrapperComponent location={location}>
        <Routes>
          <Route
            path="/"
            element={<Navigate to={`/dashboard/${defaultDashboard || 'engagement'}`} replace />}
          />
          <Route
            path="dashboard"
            element={<Navigate to={`/dashboard/${defaultDashboard || 'engagement'}`} replace />}
          />
          <Route path="dashboard/:option" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="aggregators" element={<Aggregators />} />
          <Route path="aggregator/:id" element={<Aggregator />} />
          <Route path="prospects/:id" element={<Prospects />} />
          <Route path="prospect/:id" element={<Prospect />} />
          <Route path="consumers" element={<Consumers />} />
          <Route path="consumer/:id" element={<Consumer />} />
          <Route path="fundings" element={<Fundings />} />
          <Route path="funding/:id" element={<NewFunding />} />
          <Route path="funding-old/:id" element={<Funding />} />
          <Route path="report/:id" element={<Report />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Navigate to="/settings/rules" replace />} />
          <Route path="settings/:tab" element={<Settings />} />
        </Routes>
      </RoutesWrapperComponent>
      <Footer />
    </div>
  );
}

export default MainRouter;
